import { useState } from "react";

interface ImageWithFallbackProps {
  src: string;
  alt: string;
  fallback?: string;
  className?: string;
  loading?: "lazy" | "eager";
  onClick?: () => void;
}

export const ImageWithFallback = ({
  src,
  alt,
  fallback,
  className,
  loading = "eager",
  onClick,
}: ImageWithFallbackProps) => {
  const [hasTriedFallback, setHasTriedFallback] = useState(false);
  const validSrc = src && src.trim() !== "" ? src : fallback;

  return (
    <img
      className={className}
      src={validSrc}
      loading={loading}
      alt={alt}
      onClick={onClick}
      onError={(e) => {
        if (!hasTriedFallback) {
          setHasTriedFallback(true);
          e.currentTarget.src = fallback;
        }
      }}
    />
  );
};
